import { cloneDeep } from "lodash";
import sendxAPI from '../xAPI'

const initialState = {
  snapshots: {},
  attempts: 3
};

let tempSnaps;
let dragItems;
let transformData;

export default (state = initialState, action) => {
  switch (action.type) {
    case "SAVE_SNAPSHOT":
      //Payload = {snapshot}
      tempSnaps = {};

      dragItems = document.getElementsByClassName('draggable');
      transformData = [];

      for(let i = 0; i < dragItems.length; i++){
        transformData.push({
          id: dragItems[i].id,
          transform: dragItems[i].style.transform
        });
      }

      for(let i = 1; i <= (Object.keys(state.snapshots).length + 1); i++ ){
        //Move snapshots down 1 step and save latest as back1
        if(i === 1){
          tempSnaps['back' + i] = {...action.payload.snapshot, ...{transform: transformData}};
        } else {
          tempSnaps['back' + i] = cloneDeep(state.snapshots['back' + (i - 1)]);
        }
      }

      return {
        ...state,
        ...{ snapshots: tempSnaps }
      };

    case "UNDO":
      //Payload = {lastState}
      //But don't need the payload here, only in other reducers

      if (state.attempts > 0 && Object.keys(state.snapshots).length > 0) {
        const tempSnaps2 = {};

        for(let i = 0; i < action.payload.lastState.transform.length; i++){
          if(action.payload.lastState.transform[i].id !== ""){
            const elem = document.getElementById(action.payload.lastState.transform[i].id);
            elem.style.transform = action.payload.lastState.transform[i].transform;
          }
        }

        for(let i = 1; i < (Object.keys(state.snapshots).length); i++ ){
          //Move snapshots down 1 step and save latest as back1
          tempSnaps2['back' + i] = cloneDeep(state.snapshots['back' + (i + 1)]);
        }

        state.snapshots = tempSnaps2;
        state.attempts = state.attempts - 1;

        // xAPI statement
        sendxAPI({
          // Type of statement
          verb: {
            description: "reset",
            address: "https://w3id.org/xapi/dod-isd/verbs/reset"
          },
          // Where the action occured
          context: "Protocol task: " + state.snapshots.back1.notebook.focusedTaskObj.levels["l"+state.snapshots.back1.notebook.level].task,
          // Result of the action
          result: {
            success: true,
            response: state.attempts +" attempts left"
          }
        })

        return state;

      } else {
        return state;
      }

    case "SET_UNDO_ATTEMPTS":
      //Payload = {attempts}

      return {
        ...state,
        ...{ attempts: action.payload.attempts }
      };

    default:
      return state;
  }
};
